import { Paper } from 'shared/ui/paper'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const DirectionCardSecondarySkeleton = () => {
  return (
    <Paper padding={[8, 16]}>
      <div className={s.skeletonContainer}>
        <Skeleton
          width={44}
          height={44}
          borderRadius={6}
        />

        <div className={s.names}>
          <Skeleton
            height={14}
            width={'30%'}
            borderRadius={6}
          />

          <Skeleton
            height={16}
            width={'40%'}
            borderRadius={6}
          />

          <Skeleton
            height={14}
            width={'80%'}
            borderRadius={6}
          />
        </div>
      </div>
    </Paper>
  )
}
